import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { getRoleJwt, basePort, headers, multipartHeaders, isExpiredJwt, renderRedirect, setTokenHeader, getJwtFromCookies, setMutipartTokenHeader } from "../../module_auth/AuthService"
import { CheckAndShowLogo } from "../../component/common/Logo"

import { useNavigate } from "react-router-dom";
import { AlertMessage, AlertWarn } from "../../component/common/Alert"
import { getFileUrl, getFileName, getUniqFileUrl } from "../common/BaseUtil";
import { SelectCityList } from '../common/SelectList';
import { ToastMessage } from "../../component/common/Toast"
import parse from 'html-react-parser';
import { INVALID_UPDATE_AUTHORIZATION } from '../../component/common/Message'
import { getUniqLogoUrl, getEmptyLogoUrl } from "../../component/common/BaseUtil"

import ReactQuill from 'react-quill';
import QuillResizeImage from 'quill-resize-image';
import Quill from "quill";
import 'react-quill/dist/quill.snow.css';
import "./CustomImageBlot";
Quill.register("modules/resize", QuillResizeImage); 

// url /job_reg_mypage
export function JobModiMypage() {
    const navigate = useNavigate();

    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")

    //채용상세
    const [objTitle, setObjTitle] = useState("");

    //회사정보
    const [cpName, setCpName] = useState("");
    const [cpAddress, setCpAddress] = useState("");
    const [telno, setTelno] = useState("");
    const [fullname, setFullname] = useState("");
    const [cpIntro, setCpIntro] = useState("");

    // 인사담당자정보
    const [recruiterName, setRecruiterName] = useState("");
    const [recruiterTelno, setRecruiterTelno] = useState("");
    const [recruiterEmail, setRecruiterEmail] = useState("");

    const [regJob, setRegJob] = useState("");
    const [workCity, setWorkCity] = useState("0");
    
    //근무형태 체크박스
    const [checkedWorktimeFull, setCheckedWorktimeFull] = useState(false);
    const [checkedWorktimePart, setCheckedWorktimePart] = useState(false);
    const [checkedWorktimeMini, setCheckedWorktimeMini] = useState(false);

    //비자조건 체크박스
    const [checkedVisaCondWorking, setCheckedVisaCondWorking] = useState(false);
    const [checkedVisaCondHoli, setCheckedVisaCondHoli] = useState(false);
    const [checkedVisaCondSeek, setCheckedVisaCondSeek] = useState(false);
    const [checkedVisaCondStd, setCheckedVisaCondStd] = useState(false);

    const [applyCond, setApplyCond] = useState("");
    
    const [jobDetail, setJobDetail] = useState("");
    //End 채용상세

    const [redirect, setRedirect] = useState(false);
    const [fileData, setFileData] = useState(null);

    const [fileExist, setFileExist] = useState(false);
    const [fileRemoved, setFileRemoved] = useState(false);

    const [showMessage, setShowMessage] = useState(false);
    const [message, setMessage] = useState("");

    const [showAlertWarn, setShowAlertWarn] = useState(false);
    const [alertWarn, setAlertWarn] = useState("");

    const [fileId, setFileId] = useState("");
    const [fileName, setFileName] = useState("");
    const [fileFormat, setFileFormat] = useState("");
    const [uniqFileName, setUniqFileName] = useState("");
    
    const [cityList, setCityList] = useState([]);

    const [logoName, setLogoName] = useState("");
    const [logoFormat, setLogoFormat] = useState("");
    const [uniqLogoName, setUniqLogoName] = useState("");

    //logo
    const [logoEntity, setLogoEntity] = useState(null);

    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    useEffect(() => {
        
        if(getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())){
            setRedirect(true)
        } else {
            loadEntity()
            getCityList()
        }
    }, []);

    function getCpData(){
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + '/get/cp/mypage', 
        {method:'GET', headers,
        body:JSON.stringify()})
        .then(response => response.json())
        .then(response => {
            setCpName(response.cpName)
            setCpAddress(response.cpAddress)
            setTelno(response.telno)
            setCpIntro(response.cpIntro)
            setFullname(response.fullname)
            setRecruiterName(response.recruiterName)
            setRecruiterTelno(response.recruiterTelno)
            setRecruiterEmail(response.recruiterEmail)
        }).catch(error => console.log(error))
    }

    function getCityList(){
        let url = basePort + '/get/config'
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
               setCityList(response.cityEntityList)
          }).catch(error => console.log(error))
    }

    function loadEntity(){
        let url = basePort + '/get/job/' + id
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
                //setStates for job
                setObjTitle(response.objTitle)
                setCpName(response.cpName)
                setCpAddress(response.cpAddress)
                setFullname(response.fullname)
                setTelno(response.telno)
                setRegJob(response.regJob)
                setWorkCity(response.workCity)
                // setWorkTime(response.workTime)
                setCheckedWorktimeFull(response.worktimeFull == "t" ? true:false)
                setCheckedWorktimePart(response.worktimePart == "t" ? true:false)
                setCheckedWorktimeMini(response.worktimeMini == "t" ? true:false)
                
                // setVisaCond(response.visaCond)
                setCheckedVisaCondWorking(response.visaCondWorking == "t" ? true:false)
                setCheckedVisaCondHoli(response.visaCondHoli == "t" ? true:false)
                setCheckedVisaCondSeek(response.visaCondSeek == "t" ? true:false)
                setCheckedVisaCondStd(response.visaCondStd == "t" ? true:false)

                setApplyCond(response.applyCond)
                setCpIntro(response.cpIntro == null ? "" : response.cpIntro)
                setJobDetail(response.jobDetail == null ? "" : response.jobDetail)
                console.log(response.jobDetail)
                setRecruiterName(response.recruiterName)
                setRecruiterTelno(response.recruiterTelno)
                setRecruiterEmail(response.recruiterEmail)
                if(response.fileName){
                    setFileName(response.fileName)
                    setFileFormat(response.fileFormat)
                    setUniqFileName(response.uniqFileName)
                    setFileId(response.fileId)
                    setFileExist(true)
                }
                getCityList()
          }).catch(error => console.log(error))
    }

    function clickSubmit(event) {
        event.preventDefault();
        setTokenHeader(getJwtFromCookies())
        if(getRoleJwt(getJwtFromCookies()) == "ROLE_CP"){
            fetch(basePort + '/update/job', 
                {method:'post', headers,
                          body:JSON.stringify({
                            //mbrId: mbrId,
                            id:id,
                            objTitle:objTitle,
                            regJob:regJob,
                            workCity:workCity,
                            //workTime:workTime,
                            worktimeFull:checkedWorktimeFull ? "t" : "f",
                            worktimePart:checkedWorktimePart ? "t" : "f",
                            worktimeMini:checkedWorktimeMini ? "t" : "f",

                            //visaCond:visaCond,
                            visaCondWorking:checkedVisaCondWorking ? "t" : "f",
                            visaCondHoli:checkedVisaCondHoli ? "t" : "f",
                            visaCondSeek:checkedVisaCondSeek ? "t" : "f",
                            visaCondStd:checkedVisaCondStd ? "t" : "f",
                            applyCond:applyCond,
                            jobDetail:jobDetail,
                        })})
                          .then(response => response.json())
                          .then(response => {
                            if(response.validRequest) {
                                //채용엔터티 저장완료
                                fadeOutToast(response.validationMessage)
    
                                //기존 파일 삭제시에만
                                if(fileRemoved){
                                    submitRemoveFile(fileId)
                                }
    
                                if(fileData != null){
                                    //파일 업로드시
                                    submitFile(id)
                                } else {
                                    //파일변경없을시(파일업로드를 전에 했어도 변경을 안했거나 원래 업로드 안한경우)
                                    fadeOutToast(response.validationMessage)
                                    setTimeout(function() {
                                        moveTo()
                                    }.bind(this), 3000)
                                }
                            } else {
                                //invalid by PreAuthorize
                                if(response.validationMessage == undefined){
                                    fadeOutToast(INVALID_UPDATE_AUTHORIZATION)
                                } else {
                                    fadeOutToast(response.validationMessage)
                                }
                            }
                }).catch(error => console.log(error))
        }
    }

    function fadeOutToast(msg){
        setMsgToast(msg)
        setShowToast(true)
        setTimeout(function() {
            setMsgToast("")
            setShowToast(false)
        }.bind(this), 3000);
    }

    function submitRemoveFile(fileId){
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + '/removeFile', 
            {method:'post', headers,
                      body:JSON.stringify({
                        fileId: fileId,
                    })})
                      .then(response => response.json())
                      .then(response => {
                        if(response.validRequest){

                        } else {

                        }
            }).catch(error => console.log(error))
    }

    function submitFile(objectId){
        const formData = new FormData()
        formData.append('File', fileData)
        let headers = multipartHeaders
        setMutipartTokenHeader(getJwtFromCookies())
        fetch(basePort + '/saveImage/' + objectId,
                {method:'post', headers,
                    body:formData})
                .then(response => response.json())
                .then(response => {
                    if(response.validRequest){
                        fadeOutToast("수정 완료")
                        setTimeout(function() {
                            moveTo()
                        }.bind(this), 3000)
                    } else {
                        setMessage("채용수정중에 에러가 발생되었습니다.")
                        setShowMessage(true)
                    }
        }).catch(function(error) {
        });
    }

    function moveTo() {
        navigate("/job_list_mypage");
    }

    function clickWorktimeMini() {
        if(checkedWorktimeMini){
             setCheckedWorktimeMini(false)
        } else {
             setCheckedWorktimeMini(true)
        }
     }
 
     function clickWorktimeFull() {
         if(checkedWorktimeFull){
              setCheckedWorktimeFull(false)
         } else {
              setCheckedWorktimeFull(true)
         }
     }
 
     function clickWorktimePart() {
         if(checkedWorktimePart){
              setCheckedWorktimePart(false)
         } else {
              setCheckedWorktimePart(true)
         }
     }
 
     function clickVisaCondWorking() {
         if(checkedVisaCondWorking){
             setCheckedVisaCondWorking(false)
         } else {
             setCheckedVisaCondWorking(true)
         }
     }
 
     function clickVisaCondHoli() {
         if(checkedVisaCondHoli){
             setCheckedVisaCondHoli(false)
         } else {
             setCheckedVisaCondHoli(true)
         }
     }
 
     function clickVisaCondSeek() {
         if(checkedVisaCondSeek){
             setCheckedVisaCondSeek(false)
         } else {
             setCheckedVisaCondSeek(true)
         }
     }
 
     function clickVisaCondStd() {
         if(checkedVisaCondStd){
             setCheckedVisaCondStd(false)
         } else {
             setCheckedVisaCondStd(true)
         }
     }

    function handleRegJob(event) {
        setRegJob(event.target.value);
    }

    function handleApplyCond(event) {
        setApplyCond(event.target.value);
    }

    function handleCpIntro(event) {
        setCpIntro(event.target.value);
    }


    function handleWorkCity(event) {
        setWorkCity(event.target.value);
    }

    function handleObjTitle(event) {
        setObjTitle(event.target.value);
    }

    function handleFullname(event) {
        setFullname(event.target.value);
    }

    function handleTelno(event) {
        setTelno(event.target.value);
    }

    function handleCpAddress(event) {
        setCpAddress(event.target.value);
    }

    function handleCpName(event) {
        setCpName(event.target.value);
    }

    function removeFile(){
        setFileData(null)
        setFileExist(false)
        setFileRemoved(true)
    }

    function handleChooseFile(event) {
        setStateAlertWarn(false, "")
        if(event.target.files[0] == null){
            event.target.value = '';
            return
        }
        let fileName = event.target.files[0].name
        let fileExt = fileName.split('.').pop()
        if(fileExt.toLowerCase() == "pdf"){
            setFileData(event.target.files[0])
        } else {
            setStateAlertWarn(true, "pdf 파일만 업로드 가능합니다.")
        }
    }

    function setStateAlertWarn(allowShow, message){
        setShowAlertWarn(allowShow)
        setAlertWarn(message)
    }

    function handleImage(){
        // do nothing
    }

    return (
        <div>
            {renderRedirect(redirect, '/login')}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><span>채용정보</span></li>
                        <li class="breadcrumb-item"><span>채용수정</span></li>
                    </ol>
                    <form><label class="form-label" style={{textAlign: 'left', fontWeight: 'bold'}}>제목</label>
                        <input class="form-control" type="text" maxlength="41" onChange={handleObjTitle} value={objTitle}/>
                    </form>
                    <p style={{fontWeight: 'bold', marginTop: '10px', marginBottom: '10px'}}>모집요강</p>
                    <ul class="list-group">
                        <li class="list-group-item">
                            <form style={{marginTop: '10px'}}><label class="form-label">모집부문:</label>
                                <input class="form-control" type="text" onChange={handleRegJob} value={regJob}/>
                            </form>
                            <form style={{marginTop: '10px'}}><label class="form-label">근무도시:</label>
                                <SelectCityList optionValue={workCity} cityList={cityList} handleWorkCity={handleWorkCity}/>
                            </form>
                            <form style={{marginTop: '20px'}}>
                                <label class="form-label" style={{marginRight: '10px'}} >근무형태:</label>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="worktimeFull" checked={checkedWorktimeFull} onChange={clickWorktimeFull}/>
                                    <label class="form-check-label" for="worktimeFull">풀타임</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="worktimePart" checked={checkedWorktimePart} onChange={clickWorktimePart}/>
                                    <label class="form-check-label" for="worktimePart">파트타임</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="worktimeMini" checked={checkedWorktimeMini} onChange={clickWorktimeMini}/>
                                    <label class="form-check-label" for="worktimeMini">미니잡</label>
                                </div>
                            </form>
                            <form style={{marginTop: '10px'}}>
                                <label class="form-label" style={{marginRight: '10px'}} >비자조건:</label>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="visaCondWorking" checked={checkedVisaCondWorking} onChange={clickVisaCondWorking}/>
                                    <label class="form-check-label" for="visaCondWorking">워킹비자</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="visaCondHoli" checked={checkedVisaCondHoli} onChange={clickVisaCondHoli}/>
                                    <label class="form-check-label" for="visaCondHoli">워킹홀리데이비자</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="visaCondSeek" checked={checkedVisaCondSeek} onChange={clickVisaCondSeek}/>
                                    <label class="form-check-label" for="visaCondSeek">취업준비비자</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="visaCondStd" checked={checkedVisaCondStd} onChange={clickVisaCondStd}/>
                                    <label class="form-check-label" for="visaCondStd">학생비자</label>
                                </div>
                            </form>
                            {/* <form style={{marginTop: '10px'}}><label class="form-label">지원조건:</label><input class="form-control" type="text" onChange={handleApplyCond} value={applyCond}/></form> */}
                            <form style={{marginTop: '10px', marginRight: '0', marginLeft: '0'}}>
                                <label class="form-label">모집상세:</label>
                                <div class="container" style={{height:'350px', marginBottom:'10px'}}>
                                    <ReactQuill theme="snow" value={jobDetail} onChange={setJobDetail} 
                                        style={{height: '300px', marginBottom:'10px'}}
                                        modules={{
                                            toolbar: {
                                                container: [
                                                    [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                                    [{ size: [] }],
                                                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                    [{ 'align': [] }],
                                                    [{ list: 'ordered' }, { list: 'bullet' }],
                                                    ['image'],
                                                    ['clean'],
                                                    ['code-block']
                                                ],
                                                
                                            },
                                            resize: {
                                                locale: {},
                                            },
                                        }}
                                    />
                                </div>
                            </form>
                            <form style={{marginTop:'20px', marginRight: '0', marginLeft: '0'}}>
                                <div class="container">
                                    <div class="row" hidden={!fileExist}>
                                        <a class="link-dark" href={getUniqFileUrl(uniqFileName, fileFormat)} target="_blank" style={{width:'500px'}}>
                                            <span style={{marginLeft:'5px', marginRight:'5px', marginBottom:'5px'}} class="badge bg-info">파일</span>{fileName}{fileFormat}</a>
                                        <button class="btn-close" type="button" aria-label='Close' onClick={removeFile}></button>
                                    </div>
                                    <div class="row" hidden={fileExist}>
                                        <input type="file" accept=".pdf" id="chooseFile" disabled={fileExist} onChange={handleChooseFile} style={{width:'500px'}}/>
                                    </div>
                                </div>
                            </form>
                        </li>
                    </ul>
                    
                    <p style={{fontWeight:'bold', marginTop:'10px', marginBottom:'10px'}}>기업정보</p>
                    <div className="card" style={{marginBottom: '50px'}}> 
                        <div className="card-body">
                            <div class="container text-left">
                                <div class="row g-2" >
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>회사명:</span> {cpName}</div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6" >
                                        <CheckAndShowLogo
                                            imageUrl={logoName != "" ? getUniqLogoUrl(uniqLogoName, logoFormat) : getEmptyLogoUrl("empty_logo", "png")}
                                            alt="유효한 이미지"
                                            imageAlign="left"
                                            style={{marginTop: "5px",  marginBottom: "5px"}}
                                        />
                                    </div>
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>회사주소:</span> {cpAddress}</div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        {/* <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>대표자명:</span> {fullname}</div> */}
                                    </div>
                                    {/* <div class="col-sm-12 col-md-6 col-lg-6">
                                        <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>인사담당자 전화번호:</span> {recruiterTelno}</div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>인사담당자 이메일:</span> {recruiterEmail}</div>
                                    </div> */}
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>회사소개:</span><br/>{cpIntro === null ? "" : parse(cpIntro)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <form style={{textAlign: 'center', marginBottom: '10px', marginTop: '10px'}}>
                        <button class="btn btn-secondary" type="button" onClick={moveTo} style={{marginRight: '5px'}}>취소하기</button>
                        <button class="btn btn-primary" type="button" onClick={clickSubmit}>저장하기</button>
                    </form>
                    {/* end of container */}

                    <AlertMessage show={showMessage} msg={message} />
                    <AlertWarn show={showAlertWarn} msg={alertWarn} />
                    <ToastMessage show={showToast} msg={msgToast} />
                    </div>
                </section>
            </main>
        </div>
    );
}